export const SolidButtonStyles = {
    baseStyles : "w-full text-center items-center text-iw-text font-bold px-6 py-2 shadow text-white mr-1 rounded-lg"
}